var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "business copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 3.5H7.5V4.5H6.5V3.5Z",
    fill: "#2D3958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.5 5.5H7.5V6.5H6.5V5.5Z",
    fill: "#2D3958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.5 7.5H7.5V8.5H6.5V7.5Z",
    fill: "#2D3958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.5 9.5H7.5V10.5H6.5V9.5Z",
    fill: "#2D3958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.5 3.5H9.5V4.5H8.5V3.5Z",
    fill: "#2D3958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.5 5.5H9.5V6.5H8.5V5.5Z",
    fill: "#2D3958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.5 7.5H9.5V8.5H8.5V7.5Z",
    fill: "#2D3958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.5 9.5H9.5V10.5H8.5V9.5Z",
    fill: "#2D3958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M14 13.5H11.5V4.5H12.5V12C12.5 12.1326 12.5527 12.2598 12.6464 12.3536C12.7402 12.4473 12.8674 12.5 13 12.5C13.1326 12.5 13.2598 12.4473 13.3536 12.3536C13.4473 12.2598 13.5 12.1326 13.5 12V4C13.5 3.86739 13.4473 3.74021 13.3536 3.64645C13.2598 3.55268 13.1326 3.5 13 3.5H11.5V2C11.5 1.86739 11.4473 1.74021 11.3536 1.64645C11.2598 1.55268 11.1326 1.5 11 1.5H5C4.86739 1.5 4.74021 1.55268 4.64645 1.64645C4.55268 1.74021 4.5 1.86739 4.5 2V3.5H3C2.86739 3.5 2.74021 3.55268 2.64645 3.64645C2.55268 3.74021 2.5 3.86739 2.5 4V13.5H2C1.86739 13.5 1.74021 13.5527 1.64645 13.6464C1.55268 13.7402 1.5 13.8674 1.5 14C1.5 14.1326 1.55268 14.2598 1.64645 14.3536C1.74021 14.4473 1.86739 14.5 2 14.5H14C14.1326 14.5 14.2598 14.4473 14.3536 14.3536C14.4473 14.2598 14.5 14.1326 14.5 14C14.5 13.8674 14.4473 13.7402 14.3536 13.6464C14.2598 13.5527 14.1326 13.5 14 13.5ZM3.5 4.5H4.5V12C4.5 12.1326 4.55268 12.2598 4.64645 12.3536C4.74021 12.4473 4.86739 12.5 5 12.5C5.13261 12.5 5.25979 12.4473 5.35355 12.3536C5.44732 12.2598 5.5 12.1326 5.5 12V2.5H10.5V13.5H9.5V12C9.5 11.8674 9.44732 11.7402 9.35355 11.6464C9.25979 11.5527 9.13261 11.5 9 11.5H7C6.86739 11.5 6.74021 11.5527 6.64645 11.6464C6.55268 11.7402 6.5 11.8674 6.5 12V13.5H3.5V4.5ZM8.5 13.5H7.5V12.5H8.5V13.5Z",
    fill: "#2D3958"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.56bf67b4e5ca5af93c21651a5ae1b7f4.svg";
export { ForwardRef as ReactComponent };